import { FormControl, Validators } from '@angular/forms';
import { TruckLoadingType } from '../../../../administration/hub/constants/hub.constant';
import { TruckSizeUnion } from '../../../../../../common/constants/truck-size';
import { mustNotBeBlankValidator, VEHICLE_ID_PATTERN } from '../../../../../../common';

export class AllocationTruckInformationBaseModel {
  complete = true;
  truckId: number = null;
  truckPlateId: string = null;
  truckPlateIdCountryOfOrigin: string = null;
  trailerPlateId: string = null;
  trailerPlateIdCountryOfOrigin: string = null;
  truckSize: TruckSizeUnion = null;

  constructor(params?: AllocationTruckInformationBaseModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationTruckInformationInputModel extends AllocationTruckInformationBaseModel {
  loadingTypes: TruckLoadingType[] = [];

  constructor(params?: AllocationTruckInformationOutputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationTruckInformationOutputModel extends AllocationTruckInformationBaseModel {
  loadingTypes: TruckLoadingType[] = [];

  constructor(params?: AllocationTruckInformationInputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationTruckInformationForm {
  constructor(
    model: AllocationTruckInformationInputModel,
    public truckId: FormControl<number> = new FormControl(model.truckId),
    public complete: FormControl<boolean> = new FormControl(model.complete),
    public loadingTypes: FormControl<TruckLoadingType[]> = new FormControl(model.loadingTypes, [Validators.required]),
    public truckPlateId: FormControl<string> = new FormControl(model.truckPlateId, [
      Validators.pattern(VEHICLE_ID_PATTERN),
      mustNotBeBlankValidator,
    ]),
    public trailerPlateId: FormControl<string> = new FormControl(model.trailerPlateId, [
      Validators.pattern(VEHICLE_ID_PATTERN),
      mustNotBeBlankValidator,
    ]),
    public truckPlateIdCountryOfOrigin: FormControl<string> = new FormControl(model.truckPlateIdCountryOfOrigin),
    public trailerPlateIdCountryOfOrigin: FormControl<string> = new FormControl(model.trailerPlateIdCountryOfOrigin),
    public truckSize: FormControl<TruckSizeUnion> = new FormControl(model.truckSize),
  ) {}
}
